export default __webpack_public_path__ + "static/media/template2.8b6bdf6b.svg";